import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

export const SUPPORTED_LANGUAGES = [
  'ar', 'bn', 'de', 'en', 'es', 'fa', 'fr', 'gu', 'hi', 'id',
  'it', 'ja', 'ko', 'mr', 'nl', 'pl', 'pt', 'ru', 'ta', 'te',
  'th', 'tr', 'ur', 'vi', 'zh'
];

export const RTL_LANGUAGES = ['ar', 'fa', 'ur'];

export const LANGUAGE_NAMES = {
  ar: 'العربية',
  bn: 'বাংলা',
  de: 'Deutsch',
  en: 'English',
  es: 'Español',
  fa: 'فارسی',
  fr: 'Français',
  gu: 'ગુજરાતી',
  hi: 'हिन्दी',
  id: 'Indonesia',
  it: 'Italiano',
  ja: '日本語',
  ko: '한국어',
  mr: 'मराठी',
  nl: 'Nederlands',
  pl: 'Polski',
  pt: 'Português',
  ru: 'Русский',
  ta: 'தமிழ்',
  te: 'తెలుగు',
  th: 'ภาษาไทย',
  tr: 'Türkçe',
  ur: 'اردو',
  vi: 'Tiếng Việt',
  zh: '中文'
};

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES,
    ns: ['common'],
    defaultNS: 'common',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'jeshua_lang'
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
